import React, { useEffect } from "react";
import H2Element from "../../Global Functions/h2Element";
import { useDispatch, useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";
import SearchBar from "../Main/searchBar";
import {
  changeInviteStatus,
  getInviteData,
} from "../../Redux/Actions/invitesAction";
import { ReactComponent as BackIcon } from "../../Assets/Categories/BackIcon.svg";
import SelectInput from "../../Global Functions/selectInput";
import { icons } from "../../icons";

const ViewInvite = () => {
  const dispatch = useDispatch();
  const { id } = useParams();

  useEffect(() => {
    dispatch(getInviteData(id));
  }, [dispatch, id]);

  const { invite } = useSelector((state) => state.invites || {});

  const statusUpdate = ["requested", "pending", "declined", "accepted"];

  return (
    <div
      style={{
        gridTemplateColumns: "repeat(7, 1fr)",
      }}
      className="grid-container gap-10"
    >
      <div className="margin-h-10" style={{ gridColumn: "2/8" }}>
        <SearchBar style={{ width: "max-content" }}></SearchBar>
      </div>
      <div
        className="back-icon"
        style={{
          gridColumn: "span 7",
          marginLeft: "20px",
          display: "flex",
          alignItems: "center",
          gap: "10px",
        }}
      >
        <Link to="/invites">
          <BackIcon style={{ cursor: "pointer" }} />
        </Link>
        <div>
          <h3>{invite?.data?.event?.event_name || "No Data Found"}</h3>
          <h4
            style={{
              position: "relative",
              top: "-10px",
              fontFamily: "Gilroy-Medium",
              fontSize: "14px",
              color: "black",
              fontWeight: "100",
              lineHeight: "10px",
            }}
          >
            Events/ List/ View
          </h4>
        </div>
      </div>
      <div className="overall_container">
        <div className="event_container">
          <div className="row1">
            <div className="row1_column">
              <H2Element
                label="Event Name"
                bgBlue={true}
                value={invite?.data?.event?.event_name || "No Data"}
              ></H2Element>
              <H2Element
                label="User"
                bgBlue={true}
                value={invite?.data?.user?.name || "No Data"}
              ></H2Element>
            </div>
            <hr className="event_hr" />
            <div className="row1_column">
              <H2Element
                label="User Contact Number"
                bgBlue={true}
                value={invite?.data?.user?.contact_number || "No Data"}
              ></H2Element>
              <H2Element
                label="User Email"
                bgBlue={true}
                value={invite?.data?.user?.email || "No Data"}
              ></H2Element>
            </div>
            <hr className="event_hr" />
            <div className="row1_column">
              <H2Element
                label="Start Date"
                bgBlue={true}
                value={invite?.data?.start_date || "No Data"}
              ></H2Element>
              <H2Element
                label="End Date"
                bgBlue={true}
                value={invite?.data?.end_date || "No Data"}
              ></H2Element>
            </div>
            <hr className="event_hr" />
            <div className="row1_column">
              <SelectInput
                label="Select Status"
                bgBlue
                placeholder="Select an option"
                onChange={(event) =>
                  dispatch(
                    changeInviteStatus({
                      invite_id: id,
                      status: event.target.value,
                    })
                  )
                }
                options={
                  Array.isArray(statusUpdate)
                    ? statusUpdate.map((item) => ({
                        label: item.charAt(0).toUpperCase() + item.slice(1),
                        value: item,
                      }))
                    : []
                }
              ></SelectInput>
              <H2Element
                label="Status"
                bgBlue={true}
                value={
                  invite?.data?.status?.charAt(0)?.toUpperCase() +
                    invite?.data?.status?.slice(1) || "No Data"
                }
              ></H2Element>
            </div>
          </div>
        </div>
        <div className="about_event">
          <div
            className="row1_column"
            style={{ width: "50%", display: "flex", gap: "10px" }}
          >
            <H2Element
              label="About Event"
              bgBlue={true}
              value={invite?.data?.event?.about_event || "No Data"}
            ></H2Element>
          </div>
        </div>
        <div
          style={{
            borderRadius: "20px",
            border: "1px solid #D1D1D1",
            margin: "20px",
            padding: "10px",
          }}
        >
          <h3 className="margin-0" style={{ color: "white" }}>
            Address Details
          </h3>
          <div className="address_details">
            <div
              className="row1_column"
              style={{ display: "flex", gap: "10px" }}
            >
              <img src={icons["Address"]} alt="" />
              <H2Element
                label="Street Address"
                bgBlue={true}
                value={invite?.data?.address || "No Data"}
              ></H2Element>
            </div>
            <div
              style={{ display: "flex", gap: "10px",  whiteSpace: "nowrap" }}
              className="row1_column"
            >
              <img src={icons["Place"]} alt="" />

              <H2Element
                label="Country"
                bgBlue={true}
                value={
                  invite?.data?.country?.country_name
                    ? invite?.data?.country?.country_name
                    : "No Data"
                }
              ></H2Element>
            </div>
            <div
              style={{ display: "flex", gap: "10px", whiteSpace: "nowrap" }}
              className="row1_column"
            >
              <img src={icons["Place"]} alt="" />
              <H2Element
                label="City"
                bgBlue={true}
                value={
                  invite?.data?.city?.city_name
                    ? invite?.data?.city?.city_name
                    : "No Data"
                }
              ></H2Element>
            </div>
          </div>
        </div>
        {invite?.data?.guest_list && invite?.data?.guest_list.length > 0 ? (
          <div className="end_row ">
            <div className="guest1 padding-10">
              <h3 className="margin-0" style={{ color: "white" }}>
                Guest Details(1)
              </h3>
              <div className="flex-container flex-justify-between padding-10">
                <div className="flex-container flex-justify-between gap-10">
                  <div className="row1_column">
                    <H2Element
                      label="Guest Name"
                      bgBlue={true}
                      value={invite?.data?.guest_list?.[0]?.name || "No Data"}
                    ></H2Element>
                  </div>
                </div>
              </div>
            </div>
            {Array.isArray(invite?.data?.guest_list) &&
              invite?.data.guest_list.length === 2 && (
                <div className="guest2 padding-10">
                  <h3 className="margin-0" style={{ color: "white" }}>
                    Guest Details(2)
                  </h3>
                  <div className="flex-container flex-justify-between padding-10">
                    <div className="flex-container flex-justify-between gap-10">
                      <div className="row1_column">
                        <H2Element
                          label="Guest Name"
                          bgBlue={true}
                          value={
                            invite?.data?.guest_list?.[1]?.name || "No Data"
                          }
                        ></H2Element>
                      </div>
                    </div>
                  </div>
                </div>
              )}
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default ViewInvite;

